import { IResumoLote } from "../interfaces/IResumoLote";

export const defaultResumoLote: IResumoLote = {
  idLote: 0,
  tipo: "bloquear",
  nomeEmpresa: "",
  nomeDivisao: "",
  nomeCentroCusto: "",
  nomeSolicitante: "",
  cnpj: "",
};
